module.exports = __webpack_public_path__ + "media/assets/ClosedLock-9caa23f411fa0c3fd36878b31ce883f0.svg";